import Requests from "@/services/Requests";

const state = {
  authorizeStatus: "loading",
  authorizeList: [],
};
const getters = {
  getAuthorizeList: (state) => state.authorizeList,
  getAuthorizeStatus: (state) => state.authorizeStatus,
};
const mutations = {};

const actions = {
  async GET_AUTHORIZE_LIST({ state, rootState, dispatch }) {
    console.log("GET_AUTHORIZE_LIST", rootState);
    const activeUser = rootState.account?.activeUser?.data?.userInfo || null;
    if (!activeUser) return dispatch("SIGNOUT_USER", { variant: "danger", message: "" });
    state.authorizeStatus = "loading";
    const response = await Requests.AuthorityDepartmentUser.GetAll({
      query: {
        departmentUserId: activeUser.departmentUserId,
        departmentId: activeUser.departmentInfo.id,
      },
    });
    console.log(response, "response");
    if (response.message === "OK") {
      state.authorizeStatus = "success";
      state.authorizeList = response.data.items;
    } else {
      state.authorizeStatus = "error";
    }
  },
};

export default { state, getters, mutations, actions };
